package us.laantech.laanmanage.feature.reports.z.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import us.laantech.routes.pos.reports.z.DataTable

@Composable
fun ReportCard(dt: DataTable) {
//    val df = dt.toDataFrame()

    Card(
        shape = MaterialTheme.shapes.medium,
        border = CardDefaults.outlinedCardBorder(),
        colors = CardDefaults.cardColors(containerColor = Color.LightGray),
        modifier = Modifier.fillMaxWidth().padding(4.dp)
    ) {

        Column(modifier = Modifier.padding(8.dp)) {
            Text(dt.title ?: "No title available", style = MaterialTheme.typography.titleLarge)
            Text(dt.subtitle ?: "", style = MaterialTheme.typography.bodySmall)

            val columns = dt.columns

            // Header
            Row(
                horizontalArrangement = Arrangement.SpaceBetween,
                modifier = Modifier.fillMaxWidth()
            ) {
                columns.forEachIndexed { index,  col ->
                    val textAlign = when (columns.size - index) {
                        columns.size -> TextAlign.Start
                        1 -> TextAlign.End
                        else -> TextAlign.Center
                    }
                    Text(col, modifier = Modifier.weight(1f), style = MaterialTheme.typography.labelMedium, textAlign = textAlign)
                }
            }

            // Data
            dt.rows.forEach { row ->
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    columns.forEachIndexed { index, col ->
                        val textAlign = when (columns.size - index) {
                            columns.size -> TextAlign.Start
                            1 -> TextAlign.End
                            else -> TextAlign.Center
                        }

                        Text("${row[index]} ", modifier = Modifier.weight(1f), textAlign = textAlign)

                    }
                }
            }

            // Footer
            dt.footerRow?.let { footer ->
                HorizontalDivider()

                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    columns.forEachIndexed { index, col ->
                        val textAlign = when (columns.size - index) {
                            columns.size -> TextAlign.Start
                            1 -> TextAlign.End
                            else -> TextAlign.Center
                        }

                        Text("${footer[index]} ", modifier = Modifier.weight(1f), textAlign = textAlign)

                    }
                }


            }

        }
    }
}